import React from "react";
import ErrorAlert from "~/common/Alert/ErrorAlert";
import SuccessAlert from "~/common/Alert/SuccessAlert";
interface SubmissionResultProps {
  success: boolean;
}
const SubmissionResult = ({
  success
}: SubmissionResultProps) => {
  if (success) {
    return <SuccessAlert>
        <p className="text-sm m-0">
          <strong>You&apos;re In!</strong> Be on the lookout for incoming deals
          and coupons
        </p>
      </SuccessAlert>;
  }
  return <ErrorAlert className="mb-5" data-sentry-element="ErrorAlert" data-sentry-component="SubmissionResult" data-sentry-source-file="SubmissionResult.tsx">
      <p className="text-sm m-0">Error trying to join email list</p>
    </ErrorAlert>;
};
export default SubmissionResult;